<template>
  <div class="qr-cd-guide-wrapper">
    【学校QRコード発行管理手順】
    <div>
      ➀学校QRコードを発行するため、「市町村」「地域（地区）」「施設名」「発行単位」を入力し新規登録ボタンを押下します。（QRコードを登録、発行するための行が追加されます）
    </div>
    <div>
      ②「入力用フォームダウンロード」ボタンから生徒、児童の情報を入力して頂くEXCELシートをダウンロードします。
    </div>
    <div class="sub-guide">
      ③ダウンロードしたEXCELシートに生徒、児童の情報を入力します。
    </div>
    <div class="sub-guide">
      ④EXCELシートのCSV出力ボタンからアップロード用データをCSV出力します。
    </div>
    <div>
      ⑤「アップロード」ボタンを押下し、④で作成したCSVファイルをサーバにアップロードします。（生徒、児童の情報を登録します）
    </div>
    <div>
      ⑥QRコード表示欄の「表示」ボタンを押下すると、登録された生徒、児童のQRコードを全てPDFで出力します。PDFの機能で仮QRコードを印刷します。
    </div>
  </div>
</template>

<script>
export default {
  name: "SchoolQrCodeGuide"
};
</script>
